export const asset = (path) => `/assets/${path}`;

export const contact = {
  phone: '+257 69 23 20 00',
  whatsappUrl: 'https://wa.me/25769232000',
  email: 'info@beam.bi',
  address: '245, Chaussée Prince Louis Rwagasore, Immeuble Ndamama House, Bujumbura, Burundi',
  mapQuery: 'Ndamama House Bujumbura Burundi',
};

export const brand = {
  logo: asset('logos/logo.png'),
  whiteLogo: asset('logos/white-logo.png'),
  colors: ['#6B00FE', '#5200C8', '#F7F7F7', '#F4D83A'],
};

export const services = [
  {
    slug: 'mobile-led-advertising',
    key: 'mobileLed',
    icon: 'Truck',
    image: asset('photos/mobile-led-night.webp'),
    gallery: [
      asset('photos/mobile-led-night.webp'),
      asset('photos/mobile-led-activation.webp'),
      asset('photos/mobile-led-street.webp'),
    ],
    stats: ['120K', '302.5K'],
  },
  {
    slug: 'led-billboard-advertising',
    key: 'billboard',
    icon: 'PanelTop',
    image: asset('photos/led-billboard-night.webp'),
    gallery: [
      asset('photos/led-billboard-night.webp'),
      asset('photos/led-billboard-avenue.webp'),
      asset('photos/led-billboard-detail.webp'),
    ],
    stats: ['80K', '24/7'],
  },
  {
    slug: 'mobile-cinema',
    key: 'cinema',
    icon: 'Clapperboard',
    image: asset('photos/mobile-cinema-pev.webp'),
    gallery: [asset('photos/mobile-cinema-pev.webp'), asset('photos/campaign-hpv-gavi.webp')],
    stats: ['360', 'Rural'],
  },
];

export const stats = [
  { value: '120K', key: 'dailyReach' },
  { value: '2', key: 'mediaFormats' },
];

export const projects = [
  {
    slug: 'bancobu-kira-mama',
    key: 'bancobu',
    client: 'Bancobu',
    category: 'activation',
    image: asset('photos/mobile-led-activation.webp'),
    featured: true,
    gallery: [
      asset('photos/mobile-led-activation.webp'),
      asset('photos/mobile-led-market.webp'),
      asset('photos/mobile-led-night.webp'),
    ],
  },
  {
    slug: 'hpv-rural-vaccination',
    key: 'hpv',
    client: 'Gavi',
    category: 'awareness',
    image: asset('photos/campaign-hpv-gavi.webp'),
    featured: true,
    gallery: [asset('photos/campaign-hpv-gavi.webp'), asset('photos/mobile-cinema-pev.webp')],
    videoUrl: '',
  },
  {
    slug: 'brarudi-road-safety',
    key: 'safety',
    client: 'Brarudi',
    category: 'awareness',
    image: asset('photos/campaign-road-safety.webp'),
    featured: true,
    gallery: [asset('photos/campaign-road-safety.webp'), asset('photos/campaign-safety.webp')],
    videoUrl: '',
  },
];

export const clients = ['Bancobu', 'Brarudi', 'Police Nationale', 'Croix-Rouge', 'Gavi'];
